import { finish, error } from '../../../modules/bets/actions/settle-manually';
import api from '../../../api';
import { Amount } from 'src_common/common/amount/Amount';

export function request(dispatch, { id, accountId, payout }) {
    api.post('/bets/' + id + '/settle-manually', { accountId, payout }).then(
        (data) => {
            if (data.maxBet) {
                data.maxBet = $appState.configState.precision.newFromOld(data.maxBet).value;
            }

            if (data.payout) {
                data.payout = $appState.configState.precision.newFromOld(data.payout).value;
            }
            return dispatch(finish(id, data));
        },
        ({ errors }) => dispatch(error(id, errors))
    );
}
